import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
// import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import './ShowProduct.css';
import { Server_URL } from "../config.js";

function ShowSensorDetail() {
  const [data, setData] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();

  // console.log("get into ShowSensorDetail() id", id);
  useEffect(() => {
    axios
      .get(`${Server_URL}/get_sensor/${id}`)
      // .get(`http://localhost:3022/get_sensor/${id}`)
      // .get(`http://localhost:5000/get_sensor/${id}`)
      .then((res) => { setData(res.data); })
      .catch((err) => console.log(err));
  }, [id]);

  return (
    <div className='container-fluid bg-primary-subtle'>
      <br /> <br /> <br /> <br /> <br />
      {/* <div className='container-fluid vh-100 vw-100 bg-primary-subtle'> */}
      <div className='d-flex justify-content-center'>
        <h2>Sensor SNo : {id}</h2>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
        <button className='btn xbtn-success' onClick={() => navigate(-1)}>Back</button>
      </div>
      {/* <Link to="/CRUDSensors" className='btn btn-success'>Back</Link> */}
      <br />
      <div style={{ marginLeft: '300px' }}> {
        data.map((sensor, i) => {
          return (
            <ul className='list-group' key={i++}>
              <ul className='list-group list-group-horizontal'>
                <li className='list-group-item bg-warning-subtle m-1'> SNo : <ins>{sensor["SNo"]}</ins> </li>
                <li className='list-group-item bg-warning-subtle m-1'> Size : <ins>{sensor["Size"]}</ins> </li>
                <li className='list-group-item bg-warning-subtle m-1'> PartNo : <ins>{sensor["PartNo"]}</ins> </li>
              </ul>
              <br />
              <ul className='list-group list-group-horizontal'>
                <li className='list-group-item bg-warning-subtle m-1'> Ratio : <ins>{sensor["Ratio"]}</ins> </li>
                <li className='list-group-item bg-warning-subtle m-1'> SensorOD : <ins>{sensor["SensorOD"]}</ins> </li>
                <li className='list-group-item bg-warning-subtle m-1'> SensorAA : <ins>{sensor["SensorAA"]}</ins> </li>
              </ul>
              <br />
              <ul className='list-group list-group-horizontal'>
                <li className='list-group-item bg-warning-subtle m-1'> SensorThick : <ins>{sensor["SensorThick"]}</ins> </li>
                <li className='list-group-item bg-warning-subtle m-1'> CoverVA : <ins>{sensor["CoverVA"]}</ins> </li>
                <li className='list-group-item bg-warning-subtle m-1'> ChannelRxTx : <ins>{sensor["ChannelRxTx"]}</ins> </li>
              </ul>
              <br />
              <ul className='list-group list-group-horizontal'>
                <li className='list-group-item bg-warning-subtle m-1'> ControlCard/IC : <ins>{sensor["ControlCard"]}</ins> </li>
                <li className='list-group-item bg-warning-subtle m-1'> FpcLoc : <ins>{sensor["FpcLoc"]}</ins> </li>
                <li className='list-group-item bg-warning-subtle m-1'> PrintPN : <ins>{sensor["PrintPN"]}</ins> </li>
              </ul>
              <br />
              <ul className='list-group list-group-horizontal'>
                <li className='list-group-item bg-warning-subtle m-1'> CustomerPN : <ins>{sensor["CustomerPN"]}</ins> </li>
                <li className='list-group-item bg-warning-subtle m-1'> Note : <ins>{sensor["Note"]}</ins> </li>
                <li className='list-group-item bg-warning-subtle m-1'> DrawYes : <ins>{sensor["DrawYes"]}</ins> </li>
              </ul>
            </ul>
          );
        })
      } </div>
    </div>
  );
}

export default ShowSensorDetail;
